/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
// eslint-disable-next-line import/order
import { createSelector } from "@reduxjs/toolkit";
import { orderApi } from "./api-slice";
import { IOrderListResponse, IOrderResponse } from "@bvi/api-interfaces/response/manage-base-data";

export const selectOrder = createSelector(
  (response?: IOrderListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectOrderListResult = () =>
  orderApi.endpoints.getOrderList.select();

export const selectResponse = (data?: IOrderResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};

